import { render, staticRenderFns } from "./AdminAnalytics.vue?vue&type=template&id=84a8bca4&scoped=true"
import script from "./AdminAnalytics.vue?vue&type=script&lang=js"
export * from "./AdminAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a8bca4",
  null
  
)

export default component.exports